/**
 * Copyright (c) 2024 Securisea, Inc.
 * All rights reserved.
 *
 * This is unpublished, propriety, internal
 * source code of Securisea, Inc.
 * No license is provided to any third parties.
 * If found outside of a Securisea, Inc. environment
 * report to bounty@securisea.com for a possible cash reward
 * and promptly delete all files.
 */
import React, { useState, useEffect } from "react";
import { Paper, Typography, Box, Grid, Button } from "@mui/material";
import { EvidenceRequest } from "../../types/evidencerequests";
import FileSearchPage from "./searchFiles";
import FileList from "./fileList";
import EvidenceFilesTable from "./fileList";
import { Link } from "react-router-dom";
import { getUserInfo } from "../../helpers/user";

interface EvidenceFileManagerProps {
  evidenceRequest: EvidenceRequest;
}

const EvidenceFileManager = ({ evidenceRequest }: EvidenceFileManagerProps) => {
  const [adminOrAuditor, setAdminOrAuditor] = useState(false);
  const [adminChecked, setAdminChecked] = useState(false);
  const userInfo = getUserInfo();

  useEffect(() => {
    if (userInfo) {
      setAdminOrAuditor(
        userInfo.role === "admin" || userInfo.role === "auditor"
      );
    }
    setAdminChecked(true);
  }, [userInfo]);

  return (
    <Paper sx={{ height: "100%", padding: 1 }}>
      <Typography variant="h5" sx={{ p: 2, pb: 0 }}>
        Evidence Files
      </Typography>

      <Grid>
        {adminChecked && (
          <EvidenceFilesTable
            adminOrAuditorMode={adminOrAuditor}
            evidenceRequest={evidenceRequest}
          />
        )}

        {evidenceRequest && adminOrAuditor && (
          <Box sx={{ p: 2, textAlign: "right" }}>
            <Button variant="contained">
              <Link
                to={`/file-search/?organization=${
                  evidenceRequest.organization?.id
                }&evidenceRequests=${
                  evidenceRequest.id
                }&engagements=${evidenceRequest.engagements
                  ?.map((engagement) => engagement.id)
                  .join(",")}`}
              >
                <Typography sx={{ color: "white" }}>Browse Files</Typography>
              </Link>
            </Button>
          </Box>
        )}
      </Grid>
    </Paper>
  );
};

export default EvidenceFileManager;
